import { _ as O, a as g } from "./inheritsLoose-OI-DR2K6.mjs";
import x from "react";
import m from "react-dom";
import { T as b } from "./TransitionGroupContext-gTqf7voF.mjs";
const N = {
  disabled: !1
};
var k = function(l) {
  return l.scrollTop;
}, E = "unmounted", u = "exited", p = "entering", c = "entered", T = "exiting", s = /* @__PURE__ */ function(v) {
  O(l, v);
  function l(r, e) {
    var t;
    t = v.call(this, r, e) || this;
    var n = e, i = n && !n.isMounting ? r.enter : r.appear, o;
    return t.appearStatus = null, r.in ? i ? (o = u, t.appearStatus = p) : o = c : r.unmountOnExit || r.mountOnEnter ? o = E : o = u, t.state = {
      status: o
    }, t.nextCallback = null, t;
  }
  l.getDerivedStateFromProps = function(e, t) {
    var n = e.in;
    return n && t.status === E ? {
      status: u
    } : null;
  };
  var a = l.prototype;
  return a.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, a.componentDidUpdate = function(e) {
    var t = null;
    if (e !== this.props) {
      var n = this.state.status;
      this.props.in ? n !== p && n !== c && (t = p) : (n === p || n === c) && (t = T);
    }
    this.updateStatus(!1, t);
  }, a.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, a.getTimeouts = function() {
    var e = this.props.timeout, t, n, i;
    return t = n = i = e, e != null && typeof e != "number" && (t = e.exit, n = e.enter, i = e.appear !== void 0 ? e.appear : n), {
      exit: t,
      enter: n,
      appear: i
    };
  }, a.updateStatus = function(e, t) {
    if (e === void 0 && (e = !1), t !== null)
      if (this.cancelNextCallback(), t === p) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var n = this.props.nodeRef ? this.props.nodeRef.current : m.findDOMNode(this);
          n && k(n);
        }
        this.performEnter(e);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === u && this.setState({
      status: E
    });
  }, a.performEnter = function(e) {
    var t = this, n = this.props.enter, i = this.context ? this.context.isMounting : e, o = this.props.nodeRef ? [i] : [m.findDOMNode(this), i], f = o[0], h = o[1], S = this.getTimeouts(), C = i ? S.appear : S.enter;
    if (!e && !n || N.disabled) {
      this.safeSetState({
        status: c
      }, function() {
        t.props.onEntered(f);
      });
      return;
    }
    this.props.onEnter(f, h), this.safeSetState({
      status: p
    }, function() {
      t.props.onEntering(f, h), t.onTransitionEnd(C, function() {
        t.safeSetState({
          status: c
        }, function() {
          t.props.onEntered(f, h);
        });
      });
    });
  }, a.performExit = function() {
    var e = this, t = this.props.exit, n = this.getTimeouts(), i = this.props.nodeRef ? void 0 : m.findDOMNode(this);
    if (!t || N.disabled) {
      this.safeSetState({
        status: u
      }, function() {
        e.props.onExited(i);
      });
      return;
    }
    this.props.onExit(i), this.safeSetState({
      status: T
    }, function() {
      e.props.onExiting(i), e.onTransitionEnd(n.exit, function() {
        e.safeSetState({
          status: u
        }, function() {
          e.props.onExited(i);
        });
      });
    });
  }, a.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, a.safeSetState = function(e, t) {
    t = this.setNextCallback(t), this.setState(e, t);
  }, a.setNextCallback = function(e) {
    var t = this, n = !0;
    return this.nextCallback = function(i) {
      n && (n = !1, t.nextCallback = null, e(i));
    }, this.nextCallback.cancel = function() {
      n = !1;
    }, this.nextCallback;
  }, a.onTransitionEnd = function(e, t) {
    this.setNextCallback(t);
    var n = this.props.nodeRef ? this.props.nodeRef.current : m.findDOMNode(this), i = e == null && !this.props.addEndListener;
    if (!n || i) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var o = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback], f = o[0], h = o[1];
      this.props.addEndListener(f, h);
    }
    e != null && setTimeout(this.nextCallback, e);
  }, a.render = function() {
    var e = this.state.status;
    if (e === E)
      return null;
    var t = this.props, n = t.children;
    t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef;
    var i = g(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ x.createElement(b.Provider, {
        value: null
      }, typeof n == "function" ? n(e, i) : x.cloneElement(x.Children.only(n), i))
    );
  }, l;
}(x.Component);
s.contextType = b;
s.propTypes = {};
function d() {
}
s.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: d,
  onEntering: d,
  onEntered: d,
  onExit: d,
  onExiting: d,
  onExited: d
};
s.UNMOUNTED = E;
s.EXITED = u;
s.ENTERING = p;
s.ENTERED = c;
s.EXITING = T;
export {
  s as T,
  k as f
};
//# sourceMappingURL=Transition-4HZvpgGj.mjs.map
